<template>
  <div :class="['z-select_box', showOption ? 'active' : '']">
    <div
      class="select_option"
      @click="openOptions"
      v-on="$listeners"
    >
      <span>{{ showName(value) }}</span>
      <van-icon
        name="arrow-down"
        :class="['icon', showOption ? 'active' : '']"
      />
    </div>
    <div :class="['options_box', showOption ? 'options_box_show' : '']">
      <div
        v-for="item in options"
        :key="item.key"
        :class="['options_item', item.key === value ? 'active' : '']"
        @click.stop="change(item.key, item)"
      >
        <span>{{ showName(item.key) }}</span>
      </div>
    </div>
    <div
      v-show="showOption"
      class="mask"
      @click="openOptions(false)"
    />
  </div>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showOption: false
        }
    },
    methods: {
        openOptions(bool = true) {
            this.showOption = bool
        },
        change(key, item) {
            this.openOptions(false)
            if(key === this.value) return
            this.$emit('input', key)
            this.$emit('change', key, item)
        },
        showName(key) {
            const obj = this.options.find(item => item.key === key)
            return obj?.value
        }
    }
}
</script>
<style scoped lang="less">
@import "../assets/css/variables.less";
.z-select_box {
    padding: 0 8px;
    height: 25px;
    border: 1.5px solid @bodercolor2;
    background-color: @primary-color;
    display: inline-block;
    position: relative;
    border-radius: 25px;
    color: @textcolor5;
    white-space: nowrap;
    &.active {
        border-color: @textcolor1;
        transition: all 0.3s;
    }
    .select_option {
        line-height: 25px;
        min-width: 50px;
        font-size: 9px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
            margin-right: 8px;
        }
        .icon {
            color: @textcolor3;
            transition: all 0.3s;
            &.active {
                transform: rotateZ(-180deg);
            }
        }
    }
    .options_box {
        position: absolute;
        top: 120%;
        left: 0;
        white-space: nowrap;
        background-color: @primary-color;
        line-height: 30px;
        font-size: 12px;
        border-radius: 6px;
        overflow-y: hidden;
        max-height: 300px;
        max-height: 0;
        z-index: 1000;
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
        &.options_box_show {
            border: 1.5px solid @bodercolor2;
            height: auto;
            max-height: 300px;
            overflow-y: auto;
        }
        .options_item {
            padding: 6px 30px 6px 8px;
            transition: all 0.2s;
            &:first-child {
                margin-top: 10px;
            }
            &:last-child {
                margin-bottom: 10px;
            }
            &.active {
                color: @textcolor1;
            }
            &:active {
                background-color: @activityColor;
            }
        }
    }
    .mask {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999;
    }
}
</style>